import { ProtectedRoute } from "@/components/ProtectedRoute";
import { createFileRoute } from "@tanstack/react-router";
import { ProjectTrashPage } from "../../pages/project/ProjectTrashPage";

export const Route = createFileRoute("/admin/trash")({
  component: ProtectedAdminTrashPage,
});

function ProtectedAdminTrashPage() {
  return (
    <ProtectedRoute>
      <ProjectTrashPage projectId={null} displayName="Home" />
    </ProtectedRoute>
  );
}
